import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import _ from 'lodash';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import SearchBox from '../../../../components/SearchBox';
import "react-table/react-table.css";
import CircularProgress from "../../../../components/CircularProgress";
import AddUserForm from '../../../../Forms/AddUserForms'
import DeleteUserForm from '../../../../Forms/DeleteUserForm'

import { getUsersAll, getUsers, getUsersByCompany, companyDetail, searchUser, updateUser, addUser, assignUserCompanies, userStatus, resendConfirmation } from "../../../../appRedux/actions/companiesAction";
import "react-toastify/dist/ReactToastify.css";
import { Table, Pagination } from 'antd';
import Switch from '@material-ui/core/Switch';
import "../../styles.css";
import "./style.css";

class Users extends Component {

  constructor(props) {
    super(props);
    let user = JSON.parse(localStorage.getItem('userData'));
    let role = user.role;

    let column = [
      {
        title: 'First Name',
        dataIndex: 'firstName',
        className: 'table-heading',
        sorter: true,
        width: 200
      },
      {
        title: 'Last Name',
        dataIndex: 'lastName',
        className: 'table-heading',
        sorter: true,
        width: 200
      },
      // {
      //   title: 'User Name',
      //   dataIndex: 'userName',
      //   className: 'table-heading',
      //   sorter: true,
      //   width: 250
      // },
      {
        title: 'Email',
        dataIndex: 'email',
        className: 'table-heading',
        sorter: true,
        width: 450
      }, {
        title: 'Role',
        dataIndex: 'role',
        className: 'table-heading',
        sorter: true,
        width: 100
      }, {
        title: 'Status',
        dataIndex: 'isActive',
        className: 'table-heading',
        sorter: true,
        width: 180,
        render: (text, record, index) => <span>
          {
            (record.role != 'Contact' && !record.emailconfirmed) ? (
              <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                Pending
                <Tooltip title="Resend confirmation email">
                  <IconButton
                    size="small"
                    aria-label="Resend confirmation email"
                    disabled={!!this.props.loading}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.props.resendConfirmation(record.id);
                    }}
                    style={{ marginLeft: 4, padding: 4 }}
                  >
                    <MailOutlineIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </span>
            ) : (
              <div className="users-page-status">
                {/* No switch-box class - geometry comes from style.css. */}
                <Switch color="default" checked={text} onChange={(event) => this.userStatusChange(event, record, index)} />
                <span className={text ? 'text-success' : ''}>{text ? "Active" : "Inactive"}</span>
              </div>
            )
          }
        </span>,
      }

    ];


    this.state = {
      pageSize: 50,
      currentPage: 1,
      totalRowsInTable: 0,
      fieldName: 'id',
      sortFormat: 'A',
      searchText: '',
      search: false,
      isOpen: false,
      isEdit: false,
      isAdd: false,
      isDel: false,
      isAddOpen: false,
      loading: true,
      columns: column,
      companiesData: [],
      data: '',
      usersData: [],
      CompanyID: '',
      selectedUserId: 0,
      isEditOpen: false,
      selectedUser: '',
      userId: '',
      companyId: '',
      firstName: '',
      lastName: '',
      userName: '',
      email: '',
      role: '',
      index: -1,
      selectedCompanies: []
    }
    this.deleteUser = this.deleteUser.bind(this);

  }

  handleSave(record) {


    if (this.state.selectedCompanies.length > 0) {
      let comps = this.state.selectedCompanies;
      let comps1 = [];

      let coms = comps.map((val, i) => {

        let neData;
        if (i == 0) {
          neData = {
            "CompanyId": val.value,
            "IsDefaultCompany": true
          }
        } else {
          neData = {
            "CompanyId": val.value,
          }
        }

        comps1.push(neData);
        return comps1;
      });

      this.props.assignUserCompanies(comps1, this.state.userId);

    }

    let data = {
      userId: this.state.userId,
      companyId: this.state.companyId,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      userName: this.state.userName,
      email: this.state.email,
      role: this.state.role,
    };

    this.setState({ index: -1, loading: true });
    this.props.addUser(data);

  }

  userStatusChange = (event, record, index) => {
    event.stopPropagation();
    let isChecked = event.target.checked;
    var userData = [...this.state.usersData];
    userData[index].isActive = isChecked;
    this.setState({ userData: userData, loading: true }, () => {
      let data = {
        "id": record.id,
        "status": isChecked
      };
      this.props.userStatus(data);
    });
  }

  handleCompChange = (selectedCompanies) => {

    this.setState({ selectedCompanies, err: false });
  }
  handleFormChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }
  componentDidMount() {
    let id = this.props.match.params.id;
    this.setState({ companyId: id, loading: true })
    this.listData();
    this.props.companyDetail();
  }
  listData() {
    let id = this.props.match.params.id;
    this.props.getUsersAll(id, this.state.searchText, this.state.currentPage, this.state.pageSize, this.state.fieldName, this.state.sortFormat);
  }

  componentWillReceiveProps(nextProps) {
  
    this.setState({ isOpen: nextProps.isOpen, isAddOpen: nextProps.isAddOpen, isEditOpen: nextProps.isEditOpen })
    if (nextProps.users!==undefined && nextProps.users !== this.props.users) {
      if (nextProps.users.length > 0)
        this.state.totalRowsInTable = nextProps.users[0].totalrows;
      this.setState({ usersData: nextProps.users, loading: false });
    }
    if (nextProps.company!==undefined && nextProps.company !== this.props.company) {

      let options = nextProps.company.filter(data1 => {
        return data1.companyId !== 1 && data1.isActive == true;
      }).map(data => {
        return {
          value: data.companyId,
          label: data.name
        }
      });

      this.setState({ loading: false, companiesData: options });
    }

    if (nextProps.reload == true) {
      this.setState({ loading: false }, () => {
        this.handleCancel();
        this.listData();
      });
    }


  }

  handleDelete = () => {
    // var id = record.id
    this.setState({
      isDel: true,
      edit: false,
      isEdit: false,
      CompanyID: this.state.CompanyID,
      selectedUserId: this.state.selectedItem.id
    });
  }

  handleCancel = () => {

    this.setState({ isDel: false, isEdit: false, isAdd: false });
  };

  handleAddModal = () => {
    this.setState({ isEdit: false, isAdd: true, CompanyID: this.state.CompanyID, selectedItem: false, });
  }
  handleEditModal = (record) => {
    var id = record.id;    
    var data = this.state.usersData;
    if (id != 0) {
      const selectedItem = _.find(data, { id: id });
      this.setState({
        selectedItem: _.cloneDeep(selectedItem),
        isAdd: false,
        isEdit: true,
      });
    }

  }


  handleChange = (text) => {
    var self = this;
    if (text) {

      self.state.searchText = text;


    } else {
      self.state.searchText = '';

    }
    self.state.currentPage = 1;
    this.setState({ search: true });

    clearTimeout(self.state.timeout);

    // Make a new timeout set to go off in 800ms
    self.state.timeout = setTimeout(function () {
      self.listData();

    }, 500);

  }

  // Close delete dialog only after success (reload); do not close on submit click.
  handleDelSave = () => {
    this.setState({ isDel: false, isEdit: false });
  }
  handleDelCancel = () => { this.setState({ isDel: false, isEdit: false }) }

  handleSaveUser = (state) => { this.setState({ isAdd: state }) }


  deleteUser() {
    this.setState({ isDel: true, isEdit: false });
  }

  handleTableChange = (pagination, filters, sorter) => {
    if (sorter.order) {
      this.state.fieldName = sorter.field;
      if (sorter.order == "ascend")
        this.state.sortFormat = "A";
      else
        this.state.sortFormat = "D";
    }
    else {
      this.state.fieldName = "id";
      this.state.sortFormat = "A";
    }
    this.listData();
  }

  onShowSizeChange(current, pageSize) {
    this.state.currentPage = current;
    this.state.pageSize = pageSize;
    this.listData();    
  }
  render() {
    let { columns, searchText, usersData, search, selectedItem } = this.state;
    let filteredData = (usersData || []).map((d, index) => ({
      key: index,
      ...d
    }))
    // Full-page overlay only when mutating with no Add/Edit/Delete modal open (e.g. Resend).
    // Modal path uses in-dialog spinner only — never both.
    const showPageOverlay = this.props.loading && !this.state.isAdd && !this.state.isEdit && !this.state.isDel;

    return (
      <div className="users-page">
        {showPageOverlay && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.6)',
              zIndex: 2000,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CircularProgress />
          </div>
        )}
        <AddUserForm
          handleSave={this.handleSave}
          visible={this.state.isAdd || this.state.isEdit}
          handleCancel={this.handleCancel}
          companyId={this.state.companyId}
          companiesData={this.state.companiesData}
          selectedItem={selectedItem}
          handleDelete={this.handleDelete}
          isEdit={this.state.isEdit}
        />
        <DeleteUserForm
          handleSave={this.handleDelSave}
          visible={this.state.isDel}
          handleCancel={this.handleDelCancel}
          handleDelete={this.handleDelete}
          companyId={this.state.companyId}
          userId={this.state.selectedUserId} />

        {this.state.loading && !showPageOverlay
          ?
          <div className="users-page-loader">
          <CircularProgress />
          </div>
          :
          <React.Fragment>
          <div className="users-page-header">
            <h2 className="users-page-title">{this.state.companyId == 0 ? 'Users' : 'Contacts'}</h2>
            <div className="users-page-header-actions">
                <SearchBox
                  styleName="d-none d-lg-block"
                  placeholder="Search... "
                  value={searchText}
                  onChange={(e) => { this.handleChange(e.target.value) }}
                  style={{ background: '#eeeeeeb8' }}
                />
                <Button variant="contained" color="primary" onClick={this.handleAddModal}>
                  {this.state.companyId == 0 ? 'Add User' : 'Add Contact'}
                </Button>
            </div>
          </div>
          <div className="users-page-card">
          <div className="users-page-table-wrap">
          <Table
            className="table-layout"
            columns={this.state.columns}
            dataSource={filteredData}
            rowClassName={(record) => this.state.selectedItemKey == record.key ? 'data-row selected' : 'data-row'}
            bordered={true}
            size={"small"}
            onChange={this.handleTableChange}
            loading={this.state.loading}
            pagination={false}
            onRow={(record, index) => ({
            // Only double click opens the editor, as before.
              onDoubleClick: () => this.handleEditModal(record),
            })}
          />
          </div>
            <div className="users-page-pagination">
            <Pagination
              pageSizeOptions={['10', '25', '50', '100']}
              pageSize={this.state.pageSize}
              showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
              showSizeChanger onChange={(a, b) => this.onShowSizeChange(a, b)} onShowSizeChange={(a, b) => this.onShowSizeChange(a, b)} defaultCurrent={1} total={this.state.totalRowsInTable} />
            </div>
          </div>
          </React.Fragment>
        }
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    users: state.companyReducer.users,
    companyId: state.companyReducer.companyId,
    companyName: state.companyReducer.companyName,
    company: state.companyReducer.companies,
    reload: state.companyReducer.reload,
    loading: state.companyReducer.loading,
  }
}
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    getUsers,
    userStatus,
    updateUser,
    getUsersByCompany,
    addUser,
    companyDetail,
    searchUser,
    assignUserCompanies,
    getUsersAll,
    resendConfirmation
  }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps)(Users);
